<template>
  <AdminMasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p>{{ stage == "addUser" ? "Add User" : "Add Roles" }}</p>
      </div>
      <div class="cover">
        <div class="personal" v-if="stage == 'addUser'">
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.firstName") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.firstName')"
                  v-model="firstName"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.lastName") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.lastName')"
                  class="border-0"
                  v-model="lastName"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.email") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.email')"
                  v-model="email"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.iUsers.phoneNumber") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.iUsers.phoneNumber')"
                  v-model="phoneNumber"
                  class="border-0"
                />
              </div>
            </div>

            <div class="mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.iUsers.selectAccessLevel") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <select v-model="categoryId" class="form-control">
                  <option value="select access level" disabled selected>
                    {{ $t("text.iUsers.selectAccess") }}
                  </option>
                  <option
                    :value="cat.name"
                    v-for="(cat, i) in categories"
                    :key="i"
                  >
                    {{ cat.name }}
                  </option>
                </select>
              </div>
            </div>

            <div
              class="input__group__block mt-4 col-md-6"
              v-if="
                categoryId !== 'select access level' &&
                categoryId !== 'Industry'
              "
            >
              <label class="required">
                <span class="mylabel"> select {{ categoryId }}</span>
              </label>
              <div class="d-flex align-items-center" style="height: 50px">
                <select v-model="listId">
                  <option value="select categoryList" disabled selected>
                    select {{ categoryId }}
                  </option>
                  <option
                    :value="list.id"
                    v-for="(list, i) in functionList"
                    :key="i"
                  >
                    {{ list.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <pulse-loader
            size="15px"
            v-if="funcListLoader"
            class="py-5"
          ></pulse-loader>
          <div class="mt-4 col-md-6 pl-0">
            <div class="d-flex align-items-center" style="height: 50px">
              <span class="mylabel mr-3 primary-color">
                {{ $t("text.iUsers.passwordChange") }}
              </span>
              <input
                type="checkbox"
                v-model="forcePasswordChange"
                class="border-0"
                :disabled="true"
              />
            </div>
          </div>
        </div>

        <div class="text-center mt-4 pb-4">
          <button
            :disabled="isButtonDisabled ? true : false"
            class="ep-btn ep-primary"
            @click="createUser($event)"
          >
            {{ $t("text.iUsers.createUser") }}
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
  </AdminMasterLayout>
</template>

<script>
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";
import VueTagsInput from "@johmun/vue-tags-input";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "AddStaff",
  components: {
    AdminMasterLayout,
    VueTagsInput,
    PulseLoader,
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      phoneNumber: null,
      email: null,
      isButtonDisabled: false,
      showLoader: true,
      backgroundUrl,
      role: "selectRole",
      branches: [],
      branch: "selectBranch",
      groups: [],
      // groupId: "select group",
      groupRoles: [],
      company: null,
      options: [],
      options2: [],
      options3: [],
      selected: [],
      combinedOptions: [],
      tag: "",
      tags: [],
      searchInp: "",
      showRoles: false,
      forcePasswordChange: true,
      funcListLoader: false,
      selectAll: false,
      selectAllCheckbox: false,
      categories: [],
      categoryId: "select access level",
      stage: "addUser",
      disableSelectAll: false,
      showList: false,
      listId: "select categoryList",
      functionList: [],
      usersList: [],
      isGroup: true,
      companyID: localStorage.getItem("companyID")
        ? localStorage.getItem("companyID")
        : this.$route.query.companyID,
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getRoleCategories();
      }
    },
    categoryId(cat) {
      if (cat !== "Company") {
        // this.functionList = [];
        // this.listId = this.company.id;
        console.log("company not selected");
        this.getFunctionList();
      }
    },
    selectAll(value) {
      let selected = [];
      let combinedArray = [...this.options, ...this.options2, ...this.options3];
      if (!value) {
        this.selected = selected;
        this.tags = selected;
        return;
      }
      if (value) {
        combinedArray.forEach(function (opt) {
          selected.push(opt.text);
        });
        this.selected = selected;
        this.tags = selected;
      }
    },
    // groupId() {
    //   this.getGroupRoles();
    //   this.selected = [];
    // },
    tags: {
      handler(newTags, oldTags) {
        let newSelectedArray = [];
        if (newTags.length == this.combinedOptions.length) {
          document.querySelector("#selectAllCheckbox").checked = true;
        } else {
          document.querySelector("#selectAllCheckbox").checked = false;
        }
        try {
          if (newTags[0].tiClasses) {
            newTags.forEach((tg) => {
              newSelectedArray.push(tg.text);
            });
          } else {
            newTags.forEach((tg) => {
              newSelectedArray.push(tg);
            });
          }
          if (newTags.length < 1) {
            newSelectedArray = [];
          }
        } catch {
          newSelectedArray = [];
        }
        this.selected = newSelectedArray;
      },
    },
    deep: true,
  },
  computed: {
    userName() {
      return `${this.userDetails.firstName} ${this.userDetails.lastName}`;
    },
    filteredList() {
      const sortedList = [...this.options];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
    filteredList2() {
      const sortedList = [...this.options2];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
    filteredList3() {
      const sortedList = [...this.options3];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
  },
  company() {
    return this.$store.getters.getCompanyDetails;
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      // console.log("company gotten");
    });
    if (this.$route.query.companyID) {
      this.getRoleCategories();
    }
    document.title = "Create User:: Epump Company";
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    nextStage($event) {
      $event.preventDefault();
      this.stage = "createUser";
    },
    getFunctionList() {
      this.funcListLoader = true;
      this.functionList = [];
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/DealerBranchGroup/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.companyID
          }/${this.categoryId}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.functionList = res.data;
          this.showRoles = true;
          this.showList = true;
          this.funcListLoader = false;
          res.data.forEach((el) => {
            el.text = el.name;
            el.value = el.name;
            this.selected.push(el.name);
          });
          let copiedResponse = [...res.data];
          let options = [];
          let options2 = [];
          let options3 = [];
          copiedResponse.forEach((br, index) => {
            let dataLengthFirstOneThird = copiedResponse.length / 3;
            if (index <= dataLengthFirstOneThird) {
              options.push(br);
            }
          });

          let twoThirdOfArr = copiedResponse.splice(
            copiedResponse.length / 3 + 1,
            copiedResponse.length - 1
          );
          twoThirdOfArr.forEach((br, index) => {
            let dataHalfList = parseInt(twoThirdOfArr.length / 2);
            if (index <= dataHalfList) {
              options2.push(br);
            } else {
              options3.push(br);
            }
          });

          this.options = options;
          this.options2 = options2;
          this.options3 = options3;

          this.combinedOptions = [...options, ...options2, ...options3];
          this.options.forEach((el) => {
            el.notEnabled = true;
          });
          this.options2.forEach((el) => {
            el.notEnabled = true;
          });
          this.options3.forEach((el) => {
            el.notEnabled = true;
          });
          this.disableSelectAll = true;
          document.querySelector("#selectAllCheckbox").checked = true;
        })
        .catch((error) => {
          this.funcListLoader = false;
          this.showList = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
    getRoleCategories() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Role/GroupCategories/GENSYS`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.categories = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    checkAll(e) {
      let selected = [];
      if (e.target.checked) {
        this.combinedOptions.forEach((el) => {
          selected.push(el.text);
        });
      }
      this.selected = selected;
      this.tags = selected;
    },
    toggleBranchListDropdown() {
      this.showBranchListDropDown = !this.showBranchListDropDown;
    },
    toggleChckBox($event) {
      if ($event.target.checked) {
        const getIndex = this.selected.indexOf($event.target.value);

        if (getIndex === -1) {
          this.selected.push($event.target.value);
          this.tags.push($event.target.value);
        }
      } else {
        document.querySelector("#selectAllCheckbox").checked = false;
        const getIndex = this.selected.indexOf($event.target.value);
        if (getIndex > -1) {
          this.selected.splice(getIndex, 1);
          this.tags.splice(getIndex, 1);
        }
      }
      if (this.selected.length == this.combinedOptions.length) {
        document.querySelector("#selectAllCheckbox").checked = true;
      }
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },

    // getBranches() {
    //   this.axios
    //     .get(
    //       `${configObject.apiBaseUrl}/Company/Branches/${
    //         this.$route.query.companyId
    //           ? this.$route.query.companyId
    //           : this.company.id
    //       }`,
    //       configObject.authConfig()
    //     )
    //     .then((res) => {
    //       res.data.sort((a, b) => {
    //         return a.name.toLowerCase() > b.name.toLowerCase()
    //           ? 1
    //           : b.name.toLowerCase() > a.name.toLowerCase()
    //           ? -1
    //           : 0;
    //       });
    //       this.branches = res.data;
    //     })
    //     .catch((error) => {});
    // },
    getRoleGroups() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Role/Groups`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.groups = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    // getCompanyUsers() {
    //   // this.showLoader = true;
    //   this.axios
    //     .get(
    //       `${configObject.apiBaseUrl}/Company/Usersv2/${
    //         this.$route.query.companyId
    //           ? this.$route.query.companyId
    //           : this.company.id
    //       }`,
    //       configObject.authConfig()
    //     )
    //     .then((res) => {
    //       this.usersList = res.data;
    //       // sessionStorage.clear();
    //       localStorage.setItem("companyUsersList", JSON.stringify(res.data));
    //       // this.usersList = JSON.parse(
    //       //   localStorage.getItem("companyUsersListss")
    //       // );
    //     })
    //     .catch((error) => {
    //       this.showLoader = false;
    //     });
    // },

    createUser($event) {
      $event.preventDefault();
      if (!this.firstName) {
        this.$toast.open({
          message: this.$t("text.errors.firstNameMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.lastName) {
        this.$toast.open({
          message: this.$t("text.errors.lastNameMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.phoneNumber) {
        this.$toast.open({
          message: this.$t("text.errors.contactPhoneMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.phoneNumber.length < 10 || this.phoneNumber.length > 13) {
        this.$toast.open({
          message: this.$t("text.errors.shortPhoneNumber"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (this.categoryId == "select access level") {
        this.$toast.open({
          message: "Please select a category to continue",
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (
        this.categoryId !== "Industry" &&
        this.listId == "select categoryList"
      ) {
        this.$toast.open({
          message: `"Please select a ${this.categoryId}"`,
          type: "error",
          duration: 3000,
        });
        return;
      }

      let roleIds = [];
      this.combinedOptions.forEach((opt) => {
        if (this.selected.includes(opt.value)) {
          roleIds.push(opt.id);
        }
      });

      let data = {
        userName: this.email,
        phone: this.phoneNumber,
        firstName: this.firstName,
        lastName: this.lastName,
        rolesCategory: this.categoryId,
        forcePasswordChange: this.forcePasswordChange,
        id: this.categoryId == "Industry" ? this.companyID : this.listId,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/CreateUser/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.companyID
          }`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: "Successfully created user",
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.$eventHub.$emit("getCUsers");
          this.$router.push({
            name: "industrial_admin_users",
            query: {
              companyID: this.$route.query.companyID,
            },
          });
          // this.getCompanyUsers();
          // console.log(this.usersList);
          // const particularUser = this.users.filter(
          //   (cur) => cur.email === this.email
          // );
          // const idedUser = particularUser[0];
          // console.log(particularUser[0]);
          // this.$router.push({
          //   name: "UserDetails",
          //   query: {
          //     userId: idedUser.ownerId,
          //     username: idedUser.email,
          //     name: `${idedUser.firstName} ${idedUser.lastName}`,
          //     companyId: this.$route.query.companyId
          //       ? this.$route.query.companyId
          //       : this.company.id,
          //   },
          // });

          // this.$eventHub.$emit("getCUsers");
          // this.$eventHub.$emit("getCUsersModal", this.email);
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
